export default "</channel>\n</rss>\n";